import { render, staticRenderFns } from "./AskNewPassword.vue?vue&type=template&id=ac0c1382"
import script from "./AskNewPassword.vue?vue&type=script&lang=js"
export * from "./AskNewPassword.vue?vue&type=script&lang=js"
import style0 from "./AskNewPassword.vue?vue&type=style&index=0&id=ac0c1382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports